import React from "react";
import { Box, Typography, alpha, useTheme } from "@mui/material";
import { ShoppingCart } from "@mui/icons-material";

/**
 * CartHeader Component
 * Displays cart title, icon, and item count
 */
const CartHeader = ({ itemCount }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        px: 1.5,
        py: 1.25,
        borderBottom: `2px solid ${alpha(theme.palette.divider, 0.1)}`,
        bgcolor: alpha(theme.palette.primary.main, 0.02),
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: alpha(theme.palette.primary.main, 0.1),
            border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          }}
        >
          <ShoppingCart
            sx={{ fontSize: 20, color: theme.palette.primary.main }}
          />
        </Box>
        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 800, lineHeight: 1.2, fontSize: "1rem" }}
          >
            Order Summary
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: theme.palette.text.secondary,
              fontWeight: 600,
            }}
          >
            {itemCount} {itemCount === 1 ? "item" : "items"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CartHeader;
